import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { IconChartBar, IconChevronRight } from "@tabler/icons-react";

export default function AdminSettings() {
	const { session } = useAuth();
	const navigate = useNavigate();
	const adminEmail = session?.data?.user?.email;

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
			<h3 style={{ fontSize: "0.95rem", fontWeight: 700, margin: 0 }}>
				Info Akun
			</h3>
			<div
				style={{
					padding: "1rem",
					borderRadius: "var(--radius-md)",
					border: "1px solid var(--color-border)",
					background: "var(--color-surface)",
				}}
			>
				<div style={{ marginBottom: "0.75rem" }}>
					<div style={{ fontSize: "0.72rem", color: "var(--color-muted)", fontWeight: 600 }}>
						Email
					</div>
					<div style={{ fontSize: "0.85rem", marginTop: "0.15rem" }}>
						{adminEmail}
					</div>
				</div>
				<div style={{ marginBottom: "0.75rem" }}>
					<div style={{ fontSize: "0.72rem", color: "var(--color-muted)", fontWeight: 600 }}>
						Role
					</div>
					<div style={{ fontSize: "0.85rem", marginTop: "0.15rem" }}>
						<span
							style={{
								padding: "0.15rem 0.5rem",
								borderRadius: "9999px",
								fontSize: "0.72rem",
								fontWeight: 600,
								background: "var(--color-primary)",
								color: "#fff",
							}}
						>
							admin
						</span>
					</div>
				</div>
				<div>
					<div style={{ fontSize: "0.72rem", color: "var(--color-muted)", fontWeight: 600 }}>
						Akses
					</div>
					<div style={{ fontSize: "0.85rem", marginTop: "0.15rem" }}>
						Full admin access
					</div>
				</div>
			</div>

			<h3 style={{ fontSize: "0.95rem", fontWeight: 700, margin: "0.5rem 0 0" }}>
				Pengaturan
			</h3>
			<button
				onClick={() => navigate("/manage/settings/tracking")}
				style={{
					display: "flex",
					alignItems: "center",
					gap: "0.75rem",
					padding: "0.85rem",
					borderRadius: "var(--radius-md)",
					border: "1px solid var(--color-border)",
					background: "var(--color-surface)",
					cursor: "pointer",
					textAlign: "left",
					width: "100%",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: "36px",
						height: "36px",
						borderRadius: "var(--radius-md)",
						background: "var(--color-primary-soft)",
						color: "var(--color-primary)",
						flexShrink: 0,
					}}
				>
					<IconChartBar size={18} />
				</div>
				<div style={{ flex: 1, minWidth: 0 }}>
					<div style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--color-text)" }}>Tracking</div>
					<div style={{ fontSize: "0.72rem", color: "var(--color-text-muted)" }}>Meta Pixel, TikTok, Google Analytics</div>
				</div>
				<IconChevronRight size={16} style={{ color: "var(--color-text-muted)", flexShrink: 0 }} />
			</button>
		</div>
	);
}
